
import { Injectable } from '@angular/core';
import { KeyValueEntity } from '@base/entities/BaseEntities';
import { EnumSystemOptions } from './sysenums.enum';

@Injectable()
export class SystemOptionsService {
    private systemOptions: KeyValueEntity[];
    constructor() { }

    setOptions(options: KeyValueEntity[]) {
        this.systemOptions = [...options];
    }

    mergeOptions(options: KeyValueEntity[]) {
        this.systemOptions = [...this.systemOptions, ...options];
    }

    getSystemOption(optionName: EnumSystemOptions | string) {
        if (this.systemOptions == undefined) return undefined;
        var option = this.systemOptions.find(x => x.Key == optionName);
        if (option == undefined) throw (`SystemOption ${optionName} is not defined`);
        return option.Value;
    }

    getSystemOptionAsBoolean(optionName: EnumSystemOptions | string) {
        return this.getSystemOption(optionName) == '1';
    }
}